import formValidationService from '@/services/formValidationService';

export default {
	data () {
		return {
			modalParams: {},
			activeModal: null,
			member: Grabcad.store.member,
			models: Grabcad.store.models,
			schools: Grabcad.store.schools,
			countries: Grabcad.store.countries,
			softwares: Grabcad.store.softwares,
			categories: Grabcad.store.categories,
			workplaces: Grabcad.store.workplaces,
			customModels: Grabcad.store.customModels,
			defaultModels: Grabcad.store.defaultModels,
			modelOrderOptions: Grabcad.store.modelOrderOptions,
			tutorialOrderOptions: Grabcad.store.tutorialOrderOptions,
			showLoadingMessage: false,
			formSubmitted: false,
			errors: {}
		}
	},
	created: function() {
		this.assignModels();
	},
	methods: {
		saveProfile: function() {
			this.formSubmitted = true;

			if (!this.validateForm()) return;
			axios.put('/profile', { member: this.member })
				.then(this.showSuccess).catch(this.showError);

		},
		openSoftwares: function() {
			this.activeModal = 'softwares-modal';
		},
		openCategories: function() {
			this.activeModal = 'categories-modal';
		},
		openWorkplace: function(workplace) {
			this.modalParams = { workplace: workplace };
			this.activeModal = 'workplace-modal';
		},
		openEducation: function(school) {
			this.modalParams = { school: school };
			this.activeModal = 'education-modal';
		},
		deactivateModal: function() {
			this.activeModal = null;
		},
		showSuccess: function() {
			document.location = this.member.profilePath;
		},
		orderChange: function() {
			var options = {params: {sort: this.modelOrder.id}};
			axios.get('/profile/models/order', options)
				.then(this.updateModels).catch(this.showError);
		},
		showAlert: function(alertMessage) {
			this.$eventHub.$emit('addAlert', {
				type: 'success', message: alertMessage
			});
		},
		enableLoadingMessage: function() {
			this.showLoadingMessage = true;
		},
		disableLoadingMessage: function() {
			this.showLoadingMessage = false;
		},
		showError: function(error) {
			let errorsCounter = 0;
			Object.keys(error.response.data).forEach(prop => {
				errorsCounter += 1;
				this.$eventHub.$emit('addAlert', {
					type: 'error',
					message: `Failed to update profile: ${prop} ${error.response.data[prop]}`
				})
			})
			if (!errorsCounter) {
				this.$eventHub.$emit('addAlert', {
					type: 'error',
					message: 'Something went wrong'
				})
			}
		},
		assignModels: function(customOrder) {
			if (customOrder || this.customOrder) {
				this.models = this.customModels;
			} else {
				this.models = this.defaultModels;
			}
		},
		updateModels: function(resp) {
			this.defaultModels = resp.data;
			this.assignModels(this.customOrder);
		},
		customOrderIds: function() {
			return this.customModels.map(function(model){
				return model.id;
			});
		},
		uploadAvatar: function(formData) {
			var self = this;
			axios.post('/profile/upload_avatar', formData).then(function (response) {
				self.member.avatar = response.data.avatar_url;
				self.disableLoadingMessage();
				self.showAlert(response.data.message);
			}).catch(function(error) {
				self.disableLoadingMessage();
				self.showError(error.response.data.message);
			})
		},
		pictureChanged: function (event) {
			if (event.target.files.length === 0) return;
			this.selectedFile = event.target.files[0];
			var formData = new FormData();
			formData.append('uploadedAvatar', this.selectedFile, this.selectedFile.name);
			this.enableLoadingMessage();
			this.uploadAvatar(formData)
		},
		validateForm: function () {
			this.errors = {};
			const hasCustomModelsEmpty = this.member.custom_model_order && this.customModels.length === 0;

			const fieldsToValidate = [
				{ value: this.member.name, field: "name", label: "Name", required: true },
				{ value: this.member.tagline, field: "tagline", label: "Introduction" },
				{ value: this.member.experience, field: "experience", label: "About" },
			];

			var isValid = formValidationService.validateForm(fieldsToValidate, this.errors);
			if (hasCustomModelsEmpty) {
				isValid = false;
				this.errors['custom_models'] = 'Please select at least one model or uncheck the custom ordering.';

				const multiselectElementContainer = document.querySelector('.custom-models');
				if (multiselectElementContainer) {
					multiselectElementContainer.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			}

			return isValid;
		}
	},
	watch: {
		'member.custom_model_order': function(value) {
			this.assignModels(value);
		},
		'customModels': function() {
			this.member.model_order_ids = this.customOrderIds();
		}
	},
	computed: {
		customOrder: function() {
			return this.member.custom_model_order;
		},
		modelOrder: {
			get: function() {
				var selected = this.member.project_order;
				return this.modelOrderOptions.filter(function(option) {
					return option.id === selected;
				})[0];
			},
			set: function(selected) {
				this.member.project_order = selected.id;
			}
		},
		tutorialOrder: {
			get: function() {
				var selected = this.member.tutorial_order;
				return this.tutorialOrderOptions.filter(function(option) {
					return option.id === selected;
				})[0];
			},
			set: function(selected) {
				this.member.tutorial_order = selected.id;
			}
		}
	}
}
